import axios from 'axios';
import { AdminDesignManagement, UpdatePageData } from './admin-design-management.type';
import DesignParams = AdminDesignManagement.DesignProps;
import { sectionEditConfig, logFunction, sectionViewConfig } from '../../services/logs';

export const updateDesignProps = (serviceUrl: string, value: DesignParams) => {
  return axios.put<DesignParams>(serviceUrl, { value });
};

export const getMainPageData = () => {
  return logFunction({
    config: {
      ...sectionViewConfig,
      description: 'Получение главной страницы в Управления Дизайном'
    },
    wrapperFunction() {
      return axios.get('/admin/rest-v2/cs/cms/ru/content/content?id=53c14ddb-d4ea-47fb-89d6-b73d60889bcc');
    }
  });
};

export const updatePage = (data: UpdatePageData, lang) => {
  return logFunction({
    config: {
      ...sectionEditConfig,
      description: 'Обновление страницы в Управления Дизайном'
    },
    wrapperFunction: (_) => {
      return axios.post(`/admin/rest-v2/cs/cms/${lang}/content/content/page/update`, data);
    },
    body: data
  })
};

export const getImageUrl = (serviceUrl, id) => {
  return logFunction({
    config: {
      ...sectionViewConfig,
      description: 'Получение изображения в Управления Дизайном'
    },
    wrapperFunction() {
      return axios.get(serviceUrl, { params: { id, action: 'image' } });
    },
  });
};
